import type { JDSInputProps } from './generated';
import React from 'react';

export interface InputProps extends JDSInputProps {
  ariaDescribedby?: string;
  ariaInvalid?: string;
}

export const withLogic =
  (Component: React.ComponentType<InputProps>): React.FC<InputProps> =>
  (props: InputProps) => {
    return (
      <Component
        {...{
          ...props
        }}
      />
    );
  };
